/**
 * @generated SignedSource<<35c66d1fe3da80e6066fb994a448a5b8>>
 * @relayHash 889293ef5047c9583bb7e73bf9000cdd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CompassQuerySortOrder = "ASC" | "DESC" | "%future added value";
export type CompassSearchComponentQuery = {
  after?: string | null | undefined;
  fieldFilters?: ReadonlyArray<CompassQueryFieldFilter | null | undefined> | null | undefined;
  first?: number | null | undefined;
  query?: string | null | undefined;
  sort?: ReadonlyArray<CompassQuerySort | null | undefined> | null | undefined;
};
export type CompassQueryFieldFilter = {
  filter?: CompassQueryFilter | null | undefined;
  name: string;
};
export type CompassQueryFilter = {
  eq?: string | null | undefined;
  gt?: string | null | undefined;
  gte?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  lt?: string | null | undefined;
  lte?: string | null | undefined;
  neq?: string | null | undefined;
};
export type CompassQuerySort = {
  name?: string | null | undefined;
  order?: CompassQuerySortOrder | null | undefined;
};
export type gqlCountCompassComponentsQuery$variables = {
  cloudId: string;
  query?: CompassSearchComponentQuery | null | undefined;
};
export type gqlCountCompassComponentsQuery$data = {
  readonly compass: {
    readonly searchComponents: {
      readonly __typename: "CompassSearchComponentConnection";
      readonly __typename: "CompassSearchComponentConnection";
      readonly totalCount: number | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly __typename: string;
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type gqlCountCompassComponentsQuery = {
  response: gqlCountCompassComponentsQuery$data;
  variables: gqlCountCompassComponentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "concreteType": "CompassCatalogQueryApi",
    "kind": "LinkedField",
    "name": "compass",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          }
        ],
        "kind": "LinkedField",
        "name": "searchComponents",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "totalCount"
              }
            ],
            "type": "CompassSearchComponentConnection"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              },
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errorType"
                  }
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "gqlCountCompassComponentsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "gqlCountCompassComponentsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425",
    "metadata": {},
    "name": "gqlCountCompassComponentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "db6ce5954b3b32b77dc71734e9b9557b";

export default node;
